export const savedCart = {
	savedCartList: {
		myCart: 'My Cart',
		sharedCarts: 'Shared Carts',
		owner: 'Owner',
	}
};